import {camelCase} from '@ridi/object-case-converter';
import AbstractRoot from '../../common_components/stores/AbstractRoot';
import UiStore from './Ui';
import ConversationsStore from './Conversations';
import ContactsStore from './Contacts';
import {action, reaction} from "mobx";
import axios from '../../../libs/axios_csrf';

export default class Root extends AbstractRoot {

    constructor(currentUser, localeStore, props) {
        super(camelCase(currentUser), [], localeStore);
        this.uiStore = new UiStore(this, props.chatState.viewState);
        this.conversationsStore = new ConversationsStore(this, props.chatState.currentConversationId);
        this.contactsStore = new ContactsStore(this);
    
        this.storedChatState = props.chatState;
    

        this.storeChatStateInServer = this.storeChatStateInServer.bind(this);
        this.chatStateDisposer = reaction( () => {
                let trackedData = {
                    viewState: this.uiStore.viewState,
                    currentConversation: this.uiStore.currentConversation,
                }
                return trackedData;
            },
            () => {
                this.storeChatStateInServer();
            });

    }


    @action
    storeChatStateInServer(){
        if( this.storedChatState && this.storedChatState.id ){
            if( this.uiStore.minimized || 
                ( this.uiStore.isConversation && 
                    ( this.conversationsStore.currentConversation.id != this.storedChatState.currentConversationId ||
                      this.uiStore.viewState != this.storedChatState.viewState ) ) ){ 
                axios.patch('/chat_states/' + this.storedChatState.id, {
                    chat_state: {
                        current_conversation_id: this.conversationsStore.currentConversation.id,
                        view_state: this.uiStore.viewState,
                    }
                }).then( (response) => {
                    this.storedChatState.currentConversationId = this.conversationsStore.currentConversation.id;
                    this.storedChatState.viewState = this.uiStore.viewState;
                })
                .catch( (error) => {
                        console.log("Error while storing state in server");
                        console.log(error);
                });
            }
        }
    }


    
}